import { httpPost, httpDownload, httpGet } from '../../../utils/api.utils';
import { DEFAULT_TABLE_RESULT_MODEL, REPORT_COLUMN_MODULE } from '../../../constants/external-constants';
import Moment from 'moment';

import {
    getAllInvoice,
    setAllInvoiceError,
    setAllInvoiceColSearchStr,
    sortAllInvoiceItems,
    setAllInvoicePageSize,
    setAllInvoiceFilter,
    applyAllInvoiceFilter,
    setDefaultAllInvoice,
    applyAllInvoiceStatusFilter,
    getInvoiceAccountDetailsModal,
    getInvoiceAccountCostAllocationModal,
    getAccountLinkedInvoice,
    setAccountLinkedInvoiceSearchValue,
} from "../../../constants/model-reducers/external/invoice/invoice.settings";

import { convertToFormatTimeZoneDate } from '../../../utils/helpers.utils';
const defaultState = () => ({
    isAllInvoiceLoaded: false,
    isallInvoiceError: false,
    allInvoiceItems: DEFAULT_TABLE_RESULT_MODEL,
    allInvoiceColSort: '',
    allInvoiceIsSortedAsc: false,
    allInvoiceTableFilterList: [],
    allInvoiceTableFilterApply: false,
    allInvoiceStatusFilterList: [],
    allInvoiceTableFilterStatusApply: 0,
    isInvoiceAccountDetailLoaded: false,
    isInvoiceAccountDetailsError: false,
    invoiceAccountLinkedInvoiceTable: DEFAULT_TABLE_RESULT_MODEL,
    invoiceAccountCostAllocationModal: [],
    invoiceAccountLinkedInvoice: [],
    invoiceAccountDetails: {
        accountNumber: "",
        accountType: "",
        contractID: "",
        vendor: "",
        currency: "",
        serviceType: "",
        status: "",
        client: "",
        allocationLevel: "",
        apVendorID: "",
        remitID: "",
        billingAddress: "",
        remitAddress: "",
    },

});

const initialState = defaultState();

export const invoiceInvoiceActions = {
    setDefaultAllInvoice: () => async (dispatch, state) => {
        dispatch({
            type: setDefaultAllInvoice,
            inventoryItems: DEFAULT_TABLE_RESULT_MODEL
        });
    },
    getAllInvoice: (pageIndex = 0, pageUnmount = false) => async (dispatch, state) => {
        const { Headers, Pagination } = state().invoiceInvoice.allInvoiceItems;
        const { allInvoiceIsSortedAsc, allInvoiceColSort, allInvoiceTableFilterList, allInvoiceTableFilterApply, allInvoiceStatusFilterList, allInvoiceTableFilterStatusApply } = state().invoiceInvoice;

        var userId = sessionStorage.getItem('UserID');
        const headersToSend = pageUnmount ? {} : { ...Headers };

        try {
            var data = {
                PageFilter: {
                    PageIndex: pageIndex !== undefined ? pageIndex : 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: headersToSend,
                SortedColumnName: allInvoiceColSort,
                IsSortAscending: allInvoiceIsSortedAsc,
                TableFilterList: allInvoiceTableFilterList,
                ApplyFilter: allInvoiceTableFilterApply,
                StatusFilter: allInvoiceStatusFilterList,
                ApplyStatusFilter: allInvoiceTableFilterStatusApply,
            };

            var allInvoiceItems = await httpPost('external/invoice/getAllInvoiceItems', data);

            dispatch({
                type: getAllInvoice,
                allInvoiceItems: Object.keys(allInvoiceItems).length > 0 ? allInvoiceItems : DEFAULT_TABLE_RESULT_MODEL,
                isAllInvoiceLoaded: true,
                isAllInvoiceError: false
            });
        }

        catch (e) {
            dispatch({
                type: setAllInvoiceError,
                isAllInvoiceError: true,
                isAllInvoiceLoaded: false
            });
        }
    },
    setAllInvoiceColSearchStr: (event, key) => async (dispatch, state) => {
        var val = event.target.value;
        const { allInvoiceItems } = state().invoiceInvoice;
        var allInvoiceItemsUpd = {
            ...allInvoiceItems,
            "Headers": {
                ...allInvoiceItems.Headers,
                [key]: {

                    ...allInvoiceItems.Headers[key],
                    searchString: val
                }
            }
        }

        dispatch({
            type: setAllInvoiceColSearchStr,
            data: allInvoiceItemsUpd,
            isAllInvoiceError: false,
            isAllInvoiceLoaded: true
        });
    },
    sortAllInvoiceItems: (columnClicked, isSortedAsc) => async (dispatch, state) => {
        const { PageNumber, PageSizes } = state().invoiceInvoice.allInvoiceItems.Pagination;
        const { allInvoiceItems, allInvoiceTableFilterList, allInvoiceTableFilterApply, allInvoiceStatusFilterList, allInvoiceTableFilterStatusApply } = state().invoiceInvoice;
        var data = {
            PageFilter: {
                PageIndex: PageNumber !== undefined ? PageNumber : 0,
                PageSize: allInvoiceItems.Pagination.PerPage,
                PageSizes: PageSizes
            },
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...allInvoiceItems.Headers
            },
            SortedColumnName: columnClicked,
            IsSortAscending: isSortedAsc,
            TableFilterList: allInvoiceTableFilterList,
            ApplyFilter: allInvoiceTableFilterApply,
            StatusFilter: allInvoiceStatusFilterList,
            ApplyStatusFilter: allInvoiceTableFilterStatusApply,
        };
        var resAllInvoiceItems = await httpPost('external/invoice/getAllInvoiceItems', data);
        if (resAllInvoiceItems.ok === false) {
            dispatch({
                type: setAllInvoiceError,
                isAllInvoiceError: true,
                isAllInvoiceLoaded: false
            });
        } else {
            dispatch({
                type: sortAllInvoiceItems,
                allInvoiceItems: Object.keys(resAllInvoiceItems).length > 0 ? resAllInvoiceItems : DEFAULT_TABLE_RESULT_MODEL,
                allInvoiceColSort: columnClicked,
                allInvoiceIsSortedAsc: isSortedAsc,
                isAllInvoiceLoaded: true
            });
        }
    },

    resizeAllInvoicePage: (pageSize) => async (dispatch, state) => {
        dispatch({
            type: setAllInvoicePageSize,
            pageSize: parseInt(pageSize),
        });
    },

    extractAllInvoice: () => async (dispatch, state) => {
        const { Headers } = state().invoiceInvoice.allInvoiceItems;
        const { allInvoiceIsSortedAsc, allInvoiceColSort, allInvoiceTableFilterList, allInvoiceTableFilterApply, allInvoiceStatusFilterList, allInvoiceTableFilterStatusApply } = state().invoiceInvoice;

        const dealName = sessionStorage.getItem('DealName');
        const { activeDateFormat, activeTimeZoneOffset } = state().adminSetting;

        const formattedTimeZoneDate = convertToFormatTimeZoneDate(
            new Date(),
            activeDateFormat?.Name || "YYYY-MM-DD",
            activeTimeZoneOffset?.UtcOffset || 0)
            .replace(/[<>:"/\|?*]/g, '-');   
        var filename = `ATEM ${dealName} Invoice Extract – ${formattedTimeZoneDate}`;

        var data = {
            Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
            UserId: sessionStorage.getItem('UserID'),
            EmployeeId: sessionStorage.getItem('EmployeeID'),
            Headers: {
                ...Headers
            },
            SortedColumnName: allInvoiceColSort,
            IsSortAscending: allInvoiceIsSortedAsc,
            FileName: filename,
            TableFilterList: allInvoiceTableFilterList,
            ApplyFilter: allInvoiceTableFilterApply,
            StatusFilter: allInvoiceStatusFilterList,
            ApplyStatusFilter: allInvoiceTableFilterStatusApply,
        };

        httpDownload('external/invoice/getAllExtractInvoiceItems', data)
            .then(function (response) {
                return response.blob();
            })
            .then(function (blob) {
                let downloadUrl = window.URL.createObjectURL(blob);
                //Hide Loading
                let a = document.createElement('a');
                if (window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(blob, filename);
                } else if (typeof a.download === 'undefined') {
                    window.location = downloadUrl;
                } else {
                    a.href = downloadUrl;
                    a.download = filename + '.xlsx';
                    document.body.appendChild(a);
                    a.click();
                }
            });
    },

    addAllInvoiceFilter: (tableFilter) => (dispatch, state) => {
        const { allInvoiceTableFilterList } = state().invoiceInvoice;

        var filterList = [...allInvoiceTableFilterList, tableFilter];

        dispatch({
            type: setAllInvoiceFilter,
            filterList: filterList
        })
    },

    removeAllInvoiceFilter: (removeIndex) => (dispatch, state) => {
        const { allInvoiceTableFilterList } = state().invoiceInvoice;

        var filterList = allInvoiceTableFilterList.filter((item, index) => {
            return index !== removeIndex;
        });

        dispatch({
            type: setAllInvoiceFilter,
            filterList: filterList
        })
    },

    applyAllInvoiceFilter: (isApply) => (dispatch, state) => {
        const { allInvoiceTableFilterList } = state().invoiceInvoice;

        dispatch({
            type: applyAllInvoiceFilter,
            applyFilter: isApply,
            filterList: isApply ? allInvoiceTableFilterList : []
        });
    },

    applyAllInvoiceStatusFilter: (isStatusApply) => (dispatch, state) => {
        dispatch({
            type: applyAllInvoiceStatusFilter,
            applyStatusFilter: isStatusApply,
        });
    },

    saveAllInvoiceCustomCols: (selectedCols) => async (dispatch, state) => {
        const { Headers, Pagination } = state().invoiceInvoice.allInvoiceItems;
        const { allInvoiceIsSortedAsc, allInvoiceColSort, allInvoiceTableFilterList, allInvoiceTableFilterApply, allInvoiceStatusFilterList, allInvoiceTableFilterStatusApply } = state().invoiceInvoice;

        try {
            var userId = sessionStorage.getItem('UserID');

            var customizeFormData = {
                UserId: parseInt(userId),
                ReportColumnModule: REPORT_COLUMN_MODULE.InvoiceInvoiceManagement,
                SelectedCols: selectedCols
            };

            await httpPost('external/invoice/saveInvoiceCustomizeColumns', customizeFormData);

            dispatch({
                type: setAllInvoiceError,
                isAllInvoiceError: false,
                isAllInvoiceLoaded: false
            });

            var data = {
                PageFilter: {
                    PageIndex: 0,
                    PageSize: Pagination.PerPage,
                    PageSizes: Pagination.PageSizes
                },
                Eid: JSON.parse(sessionStorage.getItem('User')).Employee.EnterpriseId,
                UserId: userId,
                EmployeeId: sessionStorage.getItem('EmployeeID'),
                Headers: {
                    ...Headers
                },
                SortedColumnName: allInvoiceColSort,
                IsSortAscending: allInvoiceIsSortedAsc,
                TableFilterList: allInvoiceTableFilterList,
                ApplyFilter: allInvoiceTableFilterApply,
                StatusFilter: allInvoiceStatusFilterList,
                ApplyStatusFilter: allInvoiceTableFilterStatusApply,
            };

            var allInvoiceItems = await httpPost('external/invoice/getAllInvoiceItems', data);

            dispatch({
                type: getAllInvoice,
                allInvoiceItems: Object.keys(allInvoiceItems).length > 0 ? allInvoiceItems : DEFAULT_TABLE_RESULT_MODEL,
                isAllInvoiceLoaded: true,
                isAllInvoiceError: false
            });
        }
        catch (e) {
            dispatch({
                type: setAllInvoiceError,
                isAllInvoiceError: true,
                isAllInvoiceLoaded: false
            });
        }
    },

    getInvoiceAccountDetailsModal: (billingAccountID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var accountDetail = await httpGet('external/invoice/getInvoiceAccountDetailsModal/' + dealName + "/" + billingAccountID);
        var invoiceAccountDetails = JSON.parse(JSON.stringify(initialState.invoiceAccountDetails));
        if (accountDetail != null) {

            invoiceAccountDetails.accountNumber = accountDetail.AccountNumber;
            invoiceAccountDetails.accountType = accountDetail.AccountType;
            invoiceAccountDetails.contractID = accountDetail.ContractName;
            invoiceAccountDetails.vendor = accountDetail.Vendor;
            invoiceAccountDetails.currency = accountDetail.Currency;
            invoiceAccountDetails.serviceType = accountDetail.ServiceType;
            invoiceAccountDetails.status = accountDetail.Status;
            invoiceAccountDetails.client = accountDetail.Client;
            invoiceAccountDetails.allocationLevel = accountDetail.AllocationLevel;
            invoiceAccountDetails.apVendorID = accountDetail.APVendorID;
            invoiceAccountDetails.remitID = accountDetail.RemitID;
            invoiceAccountDetails.billingAddress = accountDetail.BillingAddress;
            invoiceAccountDetails.remitAddress = accountDetail.RemitAddress;

            dispatch({
                type: getInvoiceAccountDetailsModal,
                invoiceAccountDetails: invoiceAccountDetails,
                isInvoiceAccountDetailLoaded: true,
                isInvoiceAccountDetailsError: false
            });
        }
    },
    getInvoiceAccountCostAllocationModal: (billingAccountID) => async (dispatch, state) => {
        const dealName = sessionStorage.getItem('DealName');
        var res = await httpGet('external/invoice/getInvoiceAccountCostAllocation/' + dealName + "/" + billingAccountID);

        if (res != null) {
            dispatch({
                type: getInvoiceAccountCostAllocationModal,
                invoiceAccountCostAllocationModal: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },
    getAccountLinkedInvoice: (billingAccountID, searchVal, pageIndex = 0) => async (dispatch, state) => {
        const { Pagination } = state().invoiceInvoice.invoiceAccountLinkedInvoiceTable;
        const dealName = sessionStorage.getItem('DealName');
        var data = {
            SearchValue: searchVal,
            PageFilter: {
                PageIndex: pageIndex !== undefined ? pageIndex : 0,
                PageSize: Pagination.PerPage,
                PageSizes: Pagination.PageSizes
            }
        }

        var res = await httpPost('external/invoice/getAccountLinkedInvoice/' + dealName + "/" + billingAccountID, data);

        if (res != null) {
            dispatch({
                type: getAccountLinkedInvoice,
                invoiceAccountLinkedInvoice: Object.keys(res).length > 0 ? res : DEFAULT_TABLE_RESULT_MODEL,
            });
        }
    },

    getLinkedInvoiceDetails: (linkInvoiceId) => async (dispatch, state) => {
        var result = await httpGet(`external/invoice/details/${linkInvoiceId}`);

        return result.data;
    },


    setAccountLinkedInvoiceSearchValue: (val, isFilter = false, filterBy = null) => (dispatch) => {
        dispatch({
            type: setAccountLinkedInvoiceSearchValue
            , value: val
            , filterBy: filterBy
            , isFilter: isFilter
        });
    },

};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case getAllInvoice:
            return {
                ...state,
                allInvoiceItems: action.allInvoiceItems,
                isAllInvoiceLoaded: action.isAllInvoiceLoaded,
                isAllInvoiceError: action.isAllInvoiceError
            };
        case setAllInvoiceError:
            return {
                ...state,
                isAllInvoiceError: action.isAllInvoiceError,
                isAllInvoiceLoaded: action.isAllInvoiceLoaded
            }
        case setAllInvoiceColSearchStr:
            return {
                ...state,
                allInvoiceItems: action.data,
                isAllInvoiceLoaded: action.isAllInvoiceLoaded,
                isAllInvoiceError: action.isAllInvoiceError
            }
        case sortAllInvoiceItems:
            return {
                ...state,
                allInvoiceItems: action.allInvoiceItems,
                allInvoiceColSort: action.allInvoiceColSort,
                allInvoiceIsSortedAsc: action.allInvoiceIsSortedAsc,
                isAllInvoiceLoaded: action.isAllInvoiceLoaded
            }
        case setAllInvoicePageSize:
            return {
                ...state,
                allInvoiceItems: {
                    ...state.allInvoiceItems,
                    Pagination: {
                        ...state.allInvoiceItems.Pagination,
                        PerPage: action.pageSize
                    }
                }
            }
        case setAllInvoiceFilter:
            return {
                ...state,
                allInvoiceTableFilterList: action.filterList
            }
        case applyAllInvoiceFilter:
            return {
                ...state,
                allInvoiceTableFilterApply: action.applyFilter,
                allInvoiceTableFilterList: action.filterList
            }
        case applyAllInvoiceStatusFilter:
            return {
                ...state,
                allInvoiceTableFilterStatusApply: action.applyStatusFilter,
            }
        case getInvoiceAccountDetailsModal:
            return {
                ...state,
                invoiceAccountDetails: action.invoiceAccountDetails
            };
        case getInvoiceAccountCostAllocationModal:
            return {
                ...state,
                invoiceAccountCostAllocationModal: action.invoiceAccountCostAllocationModal
            };
        case getAccountLinkedInvoice:
            return {
                ...state,
                invoiceAccountLinkedInvoice: action.invoiceAccountLinkedInvoice
            }
        case setAccountLinkedInvoiceSearchValue:
            return {
                ...state
                , searchValue: action.value
                , isFilter: action.isFilter
                , filterBy: action.filterBy
            };
        case setDefaultAllInvoice:
            return initialState;
        default:
            return state;
    }
};